import { 
  responseHandler, 
  titleCaseText, 
  Loading, 
  CustomTable, 
  TablePagination, 
  EditMenu, 
  DropDownFilter,
  ToolTip 
} from "./utility/Utility";
import { Formik, Field, Form, ErrorMessage, useFormikContext } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { useEffect, useState, useRef, useContext } from "react";
import { AuthContext } from '../contexts/AuthContext';
import { useNavigate } from "react-router-dom";
import {ReactComponent as ShopSVG} from '../assets/images/shop.svg';
import {ReactComponent as ProfileSVG} from '../assets/images/profile.svg';
import {ReactComponent as GiftSVG} from '../assets/images/gift.svg';
import {ReactComponent as FBSVG} from '../assets/images/facebook-like.svg';
import {ReactComponent as IGSVG} from '../assets/images/intagram-follow.svg';
import {ReactComponent as MailSVG} from '../assets/images/mail.svg';
import {ReactComponent as SMSSVG} from '../assets/images/message.svg';
import {ReactComponent as ReferSVG} from '../assets/images/refer.svg';
import {ReactComponent as ReviewSVG} from '../assets/images/review.svg';
import { ActionDescription } from "./Onboarding";

const findTitle = (key) => {
  switch(key) {
    case "facebook":
      return 'Like Facebook Page';
    case "instagram":
      return 'Follow Instagram';
    case "birthday":
      return 'Birthday';
    case "email":
      return 'Sign up for Emails';
    case "texts":
      return 'Sign up for SMS';
    case "referral":
      return "Referrals";
    case "account_creation":
      return "Create an Account";
    case "purchase":
      return "Make a Purchase";
    case "review":
      return "Leave a Review";
    default:
      return '!N/A';
  }
}
const iconClasses = {
  'purchase': <ShopSVG className="earnings-option__title-icon"/>,
  'account_creation': <ProfileSVG className="earnings-option__title-icon"/>,
  'birthday': <GiftSVG className="earnings-option__title-icon"/>,
  'facebook': <FBSVG className="earnings-option__title-icon"/>,
  'instagram': <IGSVG className="earnings-option__title-icon"/>,
  'email': <MailSVG className="earnings-option__title-icon"/>,
  'texts': <SMSSVG className="earnings-option__title-icon"/>,
  'referral': <ReferSVG className="earnings-option__title-icon"/>,
  'review': <ReviewSVG className="earnings-option__title-icon"/>
}




export const OldEarningsTable = (props) => {
  const { getJwtToken, logout, canWrite } = useContext(AuthContext);
  // Create a form for each field. Display on pop-up or on click in place for the points name
  const [program, setProgram] = props.program;
  const [option, setOption] = props.option;
  const { setIsAdding, setIsEditing, tutorial, setTutorial } = props

  const setDescription = (key, value) => {
    switch(key) {
      case "purchase":
        return `${value} points for every $1 spent.`
      case "account_creation":
        return `${value} points for signing up.`;
      case "birthday":
        return `${value} points on customer birthday.`;
      case "facebook":
        return `${value} points for liking Facebook page.`;
      case "instagram":
        return `${value} points for following Instagram page.`;
      case "email": 
        return `${value} points for signing up for emails.`;
      case "texts":
        return `${value} points for signing up for SMS.`;
      case "referral":
        return "Referrals";
      case "review":
        return `${value} points for leaving a review.`;
      default:
        return "N/A"
    }
  }

  
  
  const toggleStatus = async (key) => {
    if (!canWrite) return;
    // If email or texts, check for integration before turning on
    let nullValues = false;
    for await (let k of Object.keys(program.earnings[key])) {
      if (program.earnings[key][k] === "") {
        nullValues = true;
      }
    }
    if (nullValues) {
      responseHandler(null, null, 'Click the edit icon to finish setup before enabling.');
    } else {
      // Disable the switch
      toggleDisableEditing(key, true);
      // Update state of switch
      let newProgram = {...program};
      newProgram.earnings[key].status = newProgram.earnings[key].status === 'active' ? 'inactive' : 'active';
      setProgram(newProgram);
      
      try {
        const token = await getJwtToken();
        // Send axios PUT request to update status
        const res = await axios.put('https://api.amplifyloyalty.com/app/stores/earnings',
          {...newProgram.earnings[key], key},
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );
        if (res.data.name === 'BadRequestError') {
          logout();
        } else {
          // Respond with status
          responseHandler(res, "success");
        }
      } catch (err) {
        // Revert the switch state back to original on error
        let revertedProgram = {...program};
        revertedProgram.earnings[key].status = program.earnings[key].status;
        setProgram(revertedProgram);
        responseHandler(err.response);
      } finally {
        // Re-enable switch
        toggleDisableEditing(key, false);
      }
    }
  }

  const toggleDisableEditing = (key, disable) => {
    let editTools = document.querySelectorAll(`.earnings-option__editing--${key} > *`);
    editTools.forEach(tool => {
      if (tool.classList.contains('switch')) {
        tool.querySelector('.switch-input').disabled = disable ? true : false;
      } else {
        tool.disabled = disable ? true : false;
      }
    })
  }

  return (
    <section className="earnings-options centralize">
      <div className="earnings-option">
        <h4 className="earnings-option__title earnings-option__title--main">Ways to Earn</h4>
      </div>
      {!program && <Loading className="earnings-options__loading" />}
      {program && Object.keys(program.earnings).map(key => {
        if (program.earnings[key].status !== 'disabled') {
          return (
            <div key={key} className="earnings-option">
              <div className="earnings-option__heading">
                <h5 className="earnings-option__title">
                  {iconClasses[key]}
                  {findTitle(key)}</h5>
                <p className="earnings-option__description">{setDescription(key, program.earnings[key].points)}</p>
              </div>
              <div className={`earnings-option__editing earnings-option__editing--${key}`}>
                <label className="earnings-option__toggle switch">
                  <input
                    className="switch-input"
                    type="checkbox"
                    name={key}
                    checked={program.earnings[key].status === 'active'}
                    value={program.earnings[key].status === 'active' ? 'true' : 'false'}
                    disabled={!canWrite}
                    onChange={() => toggleStatus(key)}
                  />
                  <span className="slider"></span>
                </label>
                <button className={`earnings-option__button`}>
                  <i 
                    className={`earnings-option__edit fa-solid fa-pen-to-square${key === 'purchase' && tutorial === 2 ? ' tutorial' : ''}`} 
                    onClick={() => {
                      const newOption = {...program.earnings[key], key: key};

                      setOption(newOption); 
                      setIsEditing(true);
                      if (tutorial === 2) setTutorial(3)
                    }}
                  ></i>
                </button>
                {key === 'purchase' && tutorial === 2 && 
                  <ActionDescription 
                    text="Click the edit icon to update the settings for making a purchase."
                    style={{bottom: "-40px", width: "175px", left: "-100px"}}
                    triangle={{right: "25px", top: "-18px"}}
                  />
                }
              </div>
            </div>
          )
        }
      })}
    <div className="earnings-options__button-container" style={{position:"relative"}}>
      <button 
        className="earnings-options__add-more btn gradient" 
        disabled={!canWrite}
        onClick={() => {
          setIsAdding(true);
          if (tutorial === 4) setTutorial(5);
        }}
        style={tutorial === 4 ? {zIndex: "55"} : {}}
      >Add more</button>
      {tutorial === 4 && 
        <ActionDescription 
          text="Add more ways to earn to your program at any time."
          style={{width: "150px",right: "140px", top: "-27px"}}
          triangle={{right: "-18px", top: "calc(50% - 9px)", transform: "rotate(90deg)"}}
        />
      }
    </div>
    </section>
  )
}

export const EarningsForm = (props) => {
  const { logout, canWrite } = useContext(AuthContext);
  const readOnly = !canWrite;
  const [program, setProgram] = props.program;
  const [option, setOption] = props.option;
  const [isEditing, setIsEditing] = props.editing;
  const { setIsAdding } = props;
  const initialValues = {...option};
  delete initialValues.key;

  const updateEarnings = (values) => {
    toggleDisableEditing(true);
    values.status = values.status ? "active" : "inactive";
    let payload = {...program.earnings}
    payload[option.key] = values;
    axios.put('https://api.amplifyloyalty.com/app/stores/earnings',
      payload,
        {
          params: {
            jwt: localStorage.getItem('_id')
          }
        }
      ).then(res => {
        if (res.data.name === 'BadRequestError') {
          logout();
        } else {
          // use option key to update state
          responseHandler(res, "success");
          setOption(false); 
          let newProgram = {...program};
          newProgram.earnings[option.key] = res.data.program.earnings[option.key];
          setProgram(newProgram);
        }
      }).catch (err => {
        console.log(err);
        responseHandler(err);
      }).finally(() => {
        toggleDisableEditing(false);
      });
  }

  const toggleDisableEditing = (disable) => {
    let targets = [...document.querySelectorAll('.earnings-form__editing > *'), ...document.querySelectorAll('.earnings-form__button-container > *')];
    targets.forEach(target => {
      if (target.classList.contains('switch')) {
        target.querySelector('.switch-input').disabled = disable ? true: false;
      } else {
        target.disabled = disable ? true : false;
      }
    })
  }

  const deleteEarning = (key) => {
    let payload = {...program.earnings}
    payload[key].status = 'disabled';
    // Set table row to disabled state
    toggleDisableEditing(true);
    axios.put('https://api.amplifyloyalty.com/app/stores/earnings',
      payload,
      {
        params: {
          jwt: localStorage.getItem('_id')
        }
      }
    ).then(res => {
      if (res.data.name === 'BadRequestError') {
        logout();
      } else {
        // set state of earning to inactive & remove disabled
        let newProgram = {...program}
        newProgram.earnings[key].status = 'disabled';
        setProgram({
          ...newProgram
        })
        responseHandler(res, "success");
        setOption(false);
      }
    }).catch(err => {
      responseHandler(err);
    }).finally(() => {
      toggleDisableEditing(false);
    })
  }

  const setSchema = () => {
    // Validate for URLs
    const schema = {};
    Object.keys(initialValues).map(key => {
      switch(typeof initialValues[key]) {
        case "number":
          schema[key] = Yup.number('Must be a number.').integer('Must be a whole number.').moreThan(0, 'Must be greater than 0.').required('Field is required.');
          break;
        case "string":
          schema[key] = Yup.string().required('Field is required.');
          break;
        default:
          break;
      }
    })
    return schema;
  }
  
  const findTitleDescription = (key, option) => {
    switch(key) {
      case "points":
        if (option === "purchase") {
          return 'Customer earns per $1 spent';
        } else {
          return "Customer earns"
        }
      case "link":
        return `Link to page`;
      case "days_delayed":
        return 'Minimum days after signup'
      default:
        return "!N/A"
    }
  }
  
  return (
    <div className="popup-overlay">
      <div className="earnings-form-container">
        <Formik 
            initialValues={{
              ...initialValues,
              status: option.status === 'disabled' || option.status === 'active' ? true : false
            }}
            // enaleReinitialize={true}
            validationSchema={Yup.object(setSchema())}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              if (readOnly) return;
              updateEarnings({...values, key: option.key});
            }}
            enableReinitialize={true}
            validateOnChange={false}
            validateOnBlur={false}
          >
            <Form className="earnings-form">
              <div className="earnings-form__heading">
                <h3 className="earnings-form__title">{findTitle(option.key)}</h3>
                <div className="earnings-form__editing">
                  <label className="earnings-form__toggle-status switch">
                    <Field className="switch-input" type="checkbox" name="status" disabled={readOnly} />
                    <span className="slider"></span>
                  </label>
                  {canWrite && isEditing && option.key !== 'purchase' && (
                    <button type="button" className="earnings-form__button">
                      <i className="fa-solid fa-trash earnings-form__delete" onClick={() => deleteEarning(option.key)}></i>
                    </button>
                  )}
                </div>
              </div>
              {Object.keys(initialValues).map(key => {
                if (key !== 'status' && key !== '_id') {
                  return (
                    <>
                      <div key={key} className="earnings-form__field">
                        <label htmlFor={key}>{findTitleDescription(key, option.key)}</label>
                        <div className="earnings-form__input-container">
                          <Field className={`earnings-form__input${(typeof initialValues[key]) === "number" ? " earnings-form__input--number" : ""}`} name={key} type={typeof option[key] == "string" ? "text" : "number"} disabled={readOnly} />
                          {(typeof initialValues[key] === "number") &&
                            <div className="earnings-form__input-identifier">{key === "points" ? "points" : "days"}</div>
                          }
                        </div>
                      </div>
                      <div className="earnings-form__errors"><ErrorMessage name={key} /></div>
                    </>
                  )
                }
              })}
              <div className="earnings-form__field earnings-form__button-container">
                <button className="earnings-form__cancel-button btn" onClick={() => {
                  setOption(false); 
                  if (!isEditing) {
                    setIsAdding(true);
                  } else {
                    setIsEditing(false);
                  }
                }}>Cancel</button>
                {canWrite && <button className="earnings-form__submit-button btn gradient" type="submit">Save</button>}
              </div>
            </Form>
          </Formik>
        </div>
    </div>
  )
}

export const EarningsOptions = (props) => {
  const {program, setOption, setIsAdding, tutorial, setTutorial} = props;
  let firstAvailable = false;
  return (
    <div className="popup-overlay">
      <div className="add-earnings">
        <div className="add-earnings__section add-earnings__section--main" style={{position: "relative"}}>
          <h3 className="add-earnings__title">Ways to Earn</h3>
          <div 
            className="add-earnings__close-button close-button" 
            onClick={() => {
              setIsAdding(false);
              if (tutorial === 6) setTutorial(7);
            }}
            style={tutorial === 6 ? 
              {boxShadow: "0 0 10px #fff", position: "relative", zIndex: "55"} : 
              {}
            }
          >x</div>
          {tutorial === 6 &&
            <ActionDescription 
              text="Close and return later to add more."
              style={{width: "125px", right: "-162px", top: "-27px"}}
              triangle={{left: "-18px", top: "calc(50% - 9px)", transform: "rotate(-90deg)"}}
              setTutorial={setTutorial}
            />
          }
        </div>
          {Object.keys(program.earnings).map((key, i) => {
            if (program.earnings[key].status === 'disabled') {
              if (key === 'referral') {
                return (
                  <div key={i} className="add-earnings__section">
                    <div className="add-earnings__heading-container">
                      {iconClasses[key]}
                      <h4 className="add-earnings__name add-earnings__name--disabled">{findTitle(key)}</h4>
                    </div>
                    <button className="add-earnings__button btn btn--disabled gradient">Coming Soon</button>
                  </div>  
                )
              } else {
                if (!firstAvailable) firstAvailable = key;
                return (
                  <div key={i} className="add-earnings__section" style={{position: "relative"}}>
                    <div className="add-earnings__heading-container">
                      {iconClasses[key]}
                      <h4 className="add-earnings__name">{findTitle(key)}</h4>
                    </div>
                    <button 
                      className="add-earnings__button btn gradient" 
                      onClick={() => {
                        if (tutorial !== 5) {
                          setIsAdding(false); 
                          setOption({...program.earnings[key], key});
                        }
                        if (tutorial === 5 && key === firstAvailable) setTutorial(6);
                        
                      }}
                      style={tutorial === 5 && key === firstAvailable ? 
                        {
                          boxShadow: "0 0 10px #fff",
                          position: "relative",
                          zIndex: "55"
                        } : 
                        {}
                      }
                    >Activate</button>
                    {tutorial === 5 && key === firstAvailable && 
                      <ActionDescription 
                        text="Click Activate to add new Ways to Earn to your program."
                        style={{width: "125px", right: "-162px", top: "-27px"}}
                        triangle={{left: "-18px", top: "calc(50% - 9px)", transform: "rotate(-90deg)"}}
                        setTutorial={setTutorial}
                      />
                    }
                  </div>
                )
              }
            }
          })}
      </div>
    </div>
  )

}

export const EarningsFormContainer = (props) => {
  const { getJwtToken, logout, canWrite } = useContext(AuthContext);
  const readOnly = !canWrite;
  const [program, setProgram] = props.program;
  const [option, setOption] = props.option;
  const [isEditing, setIsEditing] = props.editing;
  const [errors, setErrors] = props.errors;
  const { setIsAdding, schema, tutorial, setTutorial } = props;
  const initialValues = {...option};
  delete initialValues.key;
  
  // If integration field exists but is empty, and there's only one option in the schema, default to it
  if (initialValues.integration === '' || initialValues.integration === undefined) {
    const integrationsForType = program?.integrations?.[option.key] || [];
    if (integrationsForType.length === 1) {
      initialValues.integration = integrationsForType[0].value;
    }
  }

  const updateEarnings = async (values, del) => {
    toggleDisableEditing(true);
    // Validate that the required integration is active before enabling the earning method.
    if (!del && values.status === true && ['review', 'email', 'texts'].includes(option.key)) {
      const integrationKey = values.integration;
      if (!integrationKey) {
        setErrors(`You must select an integration before activating.`);
        toggleDisableEditing(false);
        return;
      }
      console.log(program?.integrations);
      const integrationsForType = program?.integrations?.[option.key] || [];
      const selectedIntegration = integrationsForType.find(i => i?.value === integrationKey);
      const integrationStatus = selectedIntegration?.integrationStatus || selectedIntegration?.status;
      // console.log({integrationStatus});
      if (integrationStatus !== 'active') {
        setErrors(`The selected integration is not active. Please visit the Integrations page to connect it before enabling this.`);
        toggleDisableEditing(false);
        return;
      }
    }

    if (del) values.status = 'disabled';
    else values.status = values.status ? "active" : "inactive";
    
    try {
      const token = await getJwtToken();
      const res = await axios.put('https://api.amplifyloyalty.com/app/stores/earnings',
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      
      if (res.data.name === 'BadRequestError') {
        logout();
      } else {
        // use option key to update state
        if (tutorial === 3) setTutorial(tutorial+1);
        responseHandler(res, "success");
        let newProgram = {...program};
        newProgram.earnings[option.key] = res.data.program.earnings[option.key];
        setOption(false); 
        setProgram(newProgram);
      }
    } catch (err) {
      console.log(err);
      responseHandler(err);
      toggleDisableEditing(false);
    }
  }

  const toggleDisableEditing = async (disable) => {
    let targets = [...document.querySelectorAll('.earnings-form__input'), 
    ...document.querySelectorAll('.earnings-form__button-container > *'),
    document.querySelector('.earnings-form__toggle-status')];
    for await (let target of targets) {
      if (target) {
        try {
          if (target.classList.contains('switch')) {
            target.querySelector('.switch-input').disabled = disable ? true: false;
          } else {
            target.disabled = disable ? true : false;
          }
        } catch (err) {
          console.log(err, target);
        }
      }
    }
  }
  
  return (
    <div className="popup-overlay">
      <div className="earnings-form-container" style={(tutorial === 3) ? {overflow: "visible"} : {}}>
        <Formik
          initialValues={{
            ...initialValues,
            status: option.status === 'disabled' || option.status === 'active' ? true : false,
          }}
          validationSchema={Yup.object(schema)}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            if (readOnly) return;
            updateEarnings({...values, key: option.key});
          }}
          enableReinitialize={true}
          validateOnChange={false}
          validateOnBlur={false}
        >
          <Form className="earnings-form">
            <div className="earnings-form__heading" style={{position: "relative"}}>
              <div className="earnings-form__title">{findTitle(option.key)}</div>
              <div className="earnings-form__editing">
                <label 
                  className="earnings-form__toggle-status switch"
                  style={(tutorial === 3) ? 
                    {
                      position: "relative", 
                      zIndex: "55", 
                      boxShadow: "0 0 10px #fff",
                      borderRadius: "var(--large-border-radius)"
                    } : 
                    {}
                  }
                >
                  {/* <input className="switch-input" type="checkbox" name="status" /> */}
                  <Field className="switch-input" type="checkbox" name="status" disabled={readOnly} />
                  <span className="slider"></span>
                </label>
                {canWrite && isEditing && option.key !== 'purchase' && (
                  <div className="earnings-form__button">
                    <i className="fa-solid fa-trash earnings-form__delete" onClick={() => updateEarnings(option, true)}></i>
                  </div>
                )}
              </div>
              {(tutorial === 3) && 
                <ActionDescription 
                  text="Make sure the status is toggled on."
                  style={{width: "100px", right: "-135px", top:"-24px"}}
                  triangle={{top: "25px", left:"-18px", transform: "rotate(-90deg)"}}
                />
              }
            </div>
            <div className="earnings-form__field" 
              style={(tutorial === 3) ?
                {
                  position: "relative", 
                  zIndex: "60", 
                  backgroundColor: "#fff",
                  boxShadow: "0 0 10px #fff",
                  padding: "5px",
                  borderRadius: "var(--small-border-radius)"
                } : {}
              }
            >
              <label htmlFor="points">Customer earns {option.key === 'purchase' ? "per $1 spent" : ""}</label>
              <div className="earnings-form__input-container">
                <Field 
                  className="earnings-form__input earnings-form__input--number" 
                  name="points" 
                  type="number"
                  disabled={readOnly}
                />
                <div className="earnings-form__input-identifier">points</div>
              </div>
            </div>
            {(tutorial === 3) && 
                <ActionDescription 
                  text="Enter a number here to assign how many points a customer will earn for this action."
                  hidePopup={true}
                  style={{width: "225px", top: "-15px", right: "20%"}}
                  triangle={{bottom: "-18px", left:"calc(232px / 2)", transform: "rotate(180deg)"}}
                />
              }

            <div className="earnings-form__errors" style={{zIndex: '55', position: 'relative', textShadow: "0 0 1px #fff"}}>
              <ErrorMessage name="points" />
            </div>

            {props.children}
            {errors && <div className="earnings-form__errors">{errors}</div>}
            <div className="earnings-form__field earnings-form__button-container" style={{position: 'relative'}}>
              <button className="earnings-form__cancel-button btn" onClick={() => {
                setErrors(false);
                setOption(false); 
                if (!isEditing) {
                  setIsAdding(true);
                } else {
                  setIsEditing(false);
                }
              }}>Cancel</button>
              {!errors && canWrite && 
                <button 
                  className="earnings-form__submit-button btn gradient" 
                  type="submit"
                  style={(tutorial === 3) ? 
                    {
                      zIndex:"55", 
                      position: "relative",
                      boxShadow: "0 0 10px #fff"
                    } : 
                    {}
                  }
                  >
                    Save
                  </button>
              }
              {(tutorial === 3) && 
                <ActionDescription 
                  text="Click save to activate it."
                  style={{width: "80px", bottom: "-85px", right: "-13px"}}
                  triangle={{top: "-18px", left:"calc(50% - 9px)"}}
                  hidePopup={true}
                />
              }
            </div>
          </Form>
        </Formik>
      </div>
    </div>
  )
}

export const EarningFormField = (props) => {
  const { canWrite } = useContext(AuthContext);
  const {type, label, name, identifier, inputClass, options, tooltip, sub, disabled: disabledProp} = props;
  const disabled = disabledProp ?? !canWrite;
  return (
    <>
      <div className="earnings-form__field">
        <div className="earnings-form__label-container">
          <label htmlFor={name} style={sub ? {paddingLeft: "20px"} : {}}>{label}</label>
          {tooltip && <ToolTip message={tooltip.message} height={tooltip.height} width={tooltip.width}/>}
        </div>
          
        {type !== 'select' && 
          <div className="earnings-form__input-container">
            <Field className={`earnings-form__input ${inputClass ? inputClass : ""}`} name={name} type={type} disabled={disabled} style={type === 'checkbox' ? {width: "20px", height: "24px", margin: "0"} : {}}/>
            {identifier && <div className="earnings-form__input-identifier">{identifier}</div>}
          </div>
        }
        {type === "select" && 
          <div className="earnings-form__input-container">
            <Field className={`earnings-form__input ${inputClass ? inputClass : ""}`} name={name} as="select" disabled={disabled}>
              <option value="" disabled>Select one</option>
              {options && options.map(option => <option key={option.value} value={option.value}>{option.name}</option>)}
            </Field>
          </div>
        }
      </div>
      <div className="earnings-form__errors"><ErrorMessage name={name} /></div>
    </>
  )
}

export const OnChange = (props) => {
  const {setEarningsErrors, getEmailLists, option, setOption} = props;
  const { values, setFieldValue } = useFormikContext();
  useEffect(() => {
    setEarningsErrors(false);
    switch (values.integration) {
      case "klaviyo": 
        getEmailLists('klaviyo').then(res => {
          
          // Check if this is SMS earning and validate SMS fields are configured
          if (option.key === 'texts') {
            const smsFields = ['sms_number', 'subscribe_message', 'terms_url', 'privacy_url', 'sms_disclosure'];
            const missingFields = smsFields.filter(field => !res.data[field] || res.data[field].trim() === '');
            
            if (missingFields.length > 0) {
              setEarningsErrors('SMS fields are not fully configured in your Klaviyo integration. Please complete all SMS settings in the Integrations tab before enabling SMS earning.');
              return;
            }
          }
          
          // Handle both formats: direct array or nested in lists property
          const listsData = res.data.lists || res.data;
          let lists = listsData.map(list => {return {value: list.id, name: list.attributes.name}});
          setOption({
            ...option,
            integration: 'klaviyo',
            lists: lists
          });
          if (!values.list_id) setFieldValue('list_id', lists[0].value);
        }).catch(err => {
          console.log(err);
          setEarningsErrors('Error retrieving lists, try again later.');
        });
        break;
      case "":
        setEarningsErrors('Set up an integration before enabling emails.');
        break;
      default: 
        setEarningsErrors('That integration is not yet available');
    }
    // if the list value is empty, set it to the first value
  }, [values.integration]);
  return null;
}